<h2 mat-dialog-title i18n>Change Password</h2>
<form [formGroup]="changePasswordForm">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label i18n>New Password</mat-label>
      <input matInput type="password" formControlName="newPassword" required autocomplete="new-password" passwordrules="required: upper; required: lower; required: digit; required: [-().&@?'#,/&quot;+]" />
      @if (changePasswordForm.get('newPassword')?.hasError('required')) {
        <mat-error i18n>
          Password is required
        </mat-error>
      }
    </mat-form-field>
    <p>
      <app-password-strength
      [control]="changePasswordForm.get('newPassword')!"></app-password-strength>
    </p>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label i18n>Re-type New Password</mat-label>
      <input matInput type="password" formControlName="passwordConfirmation" required autocomplete="new-password" />
      @if (changePasswordForm.get('passwordConfirmation')?.hasError('required')) {
        <mat-error i18n>
          Re-type New Password is required
        </mat-error>
      }
    </mat-form-field>
    @if (changePasswordForm.hasError('mismatch')) {
      <mat-error i18n>
        Passwords do not match.
      </mat-error>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <ul class="list-inline list-unstyled">
      <li>
        <button class="btn btn-primary" type="submit" [disabled]="changePasswordForm.invalid"
          (click)="onSubmit()" i18n>Change
        </button>
      </li>
      <li>
        <button class="btn btn-warning btn-outline" (click)="onCancel()" i18n>Cancel</button>
      </li>
    </ul>
  </mat-dialog-actions>
</form>
